import { useContext, useMemo } from 'react';
import { List } from 'immutable';
import { useAtMentionPlugin } from 'prosemirror-user-and-team-at-mentions/js/hooks/useAtMentionPlugin';
import { CommentsContext } from '../../contexts/CommentsContext';
import { configureMentionsPlugin } from './plugins/configureMentionsPlugin';
export function useCommentSubmit({
  commentData,
  getUserIdsFromOwnerIds,
  onSubmit
}) {
  const {
    owners,
    teams,
    isUngatedForTeamMentions
  } = useContext(CommentsContext);
  const {
    mentionsPlugins: teamMentionsPlugins,
    onSave: pluginOnSave
  } = useAtMentionPlugin({
    owners,
    teams,
    onSave: processed => {
      const userIds = Array.from(commentData.atMentions ? getUserIdsFromOwnerIds(commentData.atMentions.toArray()) : []);
      const counts = isUngatedForTeamMentions ? {
        teamCount: processed.mentionTracking.teamIds.length,
        userCount: processed.mentionTracking.userIds.length
      } : undefined;
      onSubmit(commentData.html, userIds, counts);
    }
  });
  const legacyMentionsPlugins = useMemo(() => [configureMentionsPlugin({
    owners
  })], [owners]);
  const mentionsPlugins = isUngatedForTeamMentions ? teamMentionsPlugins : legacyMentionsPlugins;
  const handleSubmitClick = () => {
    if (isUngatedForTeamMentions) {
      pluginOnSave({
        atMentions: () => commentData.atMentions ? List(commentData.atMentions.map(String)) : List(),
        html: () => commentData.html
      });
    } else {
      const userIds = Array.from(commentData.atMentions ? getUserIdsFromOwnerIds(commentData.atMentions.toArray()) : []);
      onSubmit(commentData.html, userIds, undefined);
    }
  };
  return {
    mentionsPlugins,
    handleSubmitClick
  };
}